const SetHtmlFontSize = () => {
    const html = document.getElementsByTagName('html')[0];
    const { width: windowsWidth, height: windowsHeight } = window.screen;
    const GetFontSize = (data, factor) => {
        let ret = Math.ceil(data / factor);
        if (ret % 8 !== 0) {
            ret += 8;
            ret -= ret % 8;
        }
        ret = ret / 8;
        if (ret % 4 !== 0) {
            let mod = ret % 4;
            if (mod > 2) {
                ret += 4;
                ret -= mod;
            } else {
                ret -= mod;
            }
        }
        ret = ret * 8;
        return ret;
    }

    let showFontSize = GetFontSize(windowsWidth, 20);

    if (windowsWidth / 80 === windowsHeight / 27) {
        showFontSize = GetFontSize(windowsWidth, 33.1);
    } else {
        showFontSize = GetFontSize(windowsWidth, 20);
    }
    html.style.fontSize = showFontSize + 'px';
    window.fontSize = showFontSize;
}

export default SetHtmlFontSize;